<div *transloco="let t">
	<vex-page-layout mode="card">
		<vex-page-layout-header class="pb-16 flex flex-col justify-center items-start">
			<div>
				<h1 class="title mt-0 mb-1" name="settingsTitle">{{ t('settings.settings') }}</h1>
				<vex-breadcrumbs [crumbs]="this.breadCrumbService.crumbs"></vex-breadcrumbs>
			</div>
		</vex-page-layout-header>
		<vex-page-layout-content [class.container]="false" [class.px-gutter]="true" class="-mt-6">
			<div class="card overflow-auto -mt-16">
				<div class="card p-6">
					<mat-tab-group [mat-stretch-tabs]="false" [selectedIndex]="0" name="matTabGroup">
						<mat-tab label="{{ t('settings.uviLetter') }}">
							<ng-template matTabContent>
								<ara-uvi-letter-settings></ara-uvi-letter-settings>
							</ng-template>
						</mat-tab>

						@if (sessionService.isDevRole() || sessionService.isSupportRole()) {
							<mat-tab label="{{ t('documentTransfer.title') }}">
								<ng-template matTabContent>
									<vex-document-transfer-settings></vex-document-transfer-settings>
								</ng-template>
							</mat-tab>
						}

						@if (sessionService.isDevRole() || sessionService.isSupportRole()) {
							<mat-tab label="{{ t('settings.devSettings.devSettings') }}">
								<ng-template matTabContent>
									<dev-settings></dev-settings>
								</ng-template>
							</mat-tab>
						}
					</mat-tab-group>
				</div>
			</div>
		</vex-page-layout-content>
	</vex-page-layout>
</div>
